import * as React from 'react';
import { sortBasedOnList } from '../utils';

export type Table6Data = { [key: string]: Table6Row }
export type Table6Row = {
  totalTotal: number;
  totalUsed: number;
  totalNotUsed: number;
  totalUnknown: number;
  killedTotal: number;
  killedUsed: number;
  killedNotUsed: number;
  killedUnknown: number;
  aInjuriesTotal: number;
  aInjuriesUsed: number;
  aInjuriesNotUsed: number;
  aInjuriesUnknown: number;
  otherInjuriesTotal: number;
  otherInjuriesUsed: number;
  otherInjuriesNotUsed: number;
  otherInjuriesUnknown: number;
  noInjuriesTotal: number;
  noInjuriesUsed: number;
  noInjuriesNotUsed: number;
  noInjuriesUnknown: number;
}

interface ITable6ClassProps {
  data: any;
}

interface ITable6State { }

const initialState: ITable6State = {};

const sortOrder = [
  "0-4 Child Restraint",
  "0-4 Seat Belt",
  "0-4 Child Total",
  "5-9",
  "10-14",
  "15",
  "16",
  "17",
  "18",
  "19",
  "20",
  "21",
  "22",
  "23",
  "24",
  "25-34",
  "35-44",
  "45-54",
  "55-64",
  "65-74",
  "75 and older",
  "Age not stated",
  "TOTALS",
];

export default class Table6 extends React.Component<ITable6ClassProps, ITable6State> {
  public constructor(props: any) {
    super(props);
    this.state = initialState;
  };

  public render() {
    return (
      <React.Fragment>
        {!this.props.data && (
          <p>Loading....</p>
        )}
        {this.props.data && (
          <table className="ss-table summaryTable1">
            <colgroup>
              <col style={{ width: 157 }} />
              <col style={{ width: 52 }} />
              <col style={{ width: 52 }} />
              <col style={{ width: 52 }} />
              <col style={{ width: 52 }} />
              <col style={{ width: 52 }} />
              <col style={{ width: 52 }} />
              <col style={{ width: 52 }} />
              <col style={{ width: 52 }} />
              <col style={{ width: 52 }} />
              <col style={{ width: 52 }} />
              <col style={{ width: 52 }} />
              <col style={{ width: 52 }} />
              <col style={{ width: 52 }} />
              <col style={{ width: 52 }} />
              <col style={{ width: 52 }} />
              <col style={{ width: 52 }} />
              <col style={{ width: 52 }} />
              <col style={{ width: 52 }} />
              <col style={{ width: 52 }} />
              <col style={{ width: 52 }} />
            </colgroup>
            <thead>
              <tr>
                <th rowSpan={3} className="border-right-bold">
                  <div className="ss-table-header">
                    <span className="header-number" style={{ border: 'none' }}>6</span>
                    <div style={{ width: '3px', height: '80px', borderLeft: '3px solid black' }} />
                    <span className="header-text">RESTRAINT USE</span>
                  </div>
                </th>
                <th colSpan={20}>DRIVERS AND PASSENGERS OF VEHICLE LIKELY TO HAVE RESTRAINTS</th>
              </tr>
              <tr>
                <th colSpan={4} className="border-right-bold">TOTAL</th>
                <th colSpan={4} className="border-right-bold">KILLED</th>
                <th colSpan={4} className="border-right-bold">A* INJURIES</th>
                <th colSpan={4} className="border-right-bold">OTHER INJURIES</th>
                <th colSpan={4}>NO INJURY</th>
              </tr>
              <tr>
                {/* Total  */}
                <th>TOTAL</th>
                <th>USED</th>
                <th>NOT USED</th>
                <th className="border-right-bold">UNK</th>
                {/* Killed  */}
                <th>TOTAL</th>
                <th>USED</th>
                <th>NOT USED</th>
                <th className="border-right-bold">UNK</th>
                {/* A* Injuries  */}
                <th>TOTAL</th>
                <th>USED</th>
                <th>NOT USED</th>
                <th className="border-right-bold">UNK</th>
                {/* Other Injuries  */}
                <th>TOTAL</th>
                <th>USED</th>
                <th>NOT USED</th>
                <th className="border-right-bold">UNK</th>
                {/* No Injuries  */}
                <th>TOTAL</th>
                <th>USED</th>
                <th>NOT USED</th>
                <th>UNK</th>
              </tr>
            </thead>
            <tbody>
              {sortBasedOnList(this.props.data, sortOrder).map((key, index) =>
                <tr key={key} className={key === "TOTALS" ? "border-bold bold-text" : null}>
                  <td className="border-right-bold" style={[0, 1].some(n => n === index) ? { paddingLeft: 10 } : {}}>{key}</td>
                  <td className="numberTotals">{this.props.data[key].totalTotal}</td>
                  <td className="numberTotals">{this.props.data[key].totalUsed}</td>
                  <td className="numberTotals">{this.props.data[key].totalNotUsed}</td>
                  <td className="numberTotals border-right-bold">{this.props.data[key].totalUnknown}</td>
                  <td className="numberTotals">{this.props.data[key].killedTotal}</td>
                  <td className="numberTotals">{this.props.data[key].killedUsed}</td>
                  <td className="numberTotals">{this.props.data[key].killedNotUsed}</td>
                  <td className="numberTotals border-right-bold">{this.props.data[key].killedUnknown}</td>
                  <td className="numberTotals">{this.props.data[key].aInjuriesTotal}</td>
                  <td className="numberTotals">{this.props.data[key].aInjuriesUsed}</td>
                  <td className="numberTotals">{this.props.data[key].aInjuriesNotUsed}</td>
                  <td className="numberTotals border-right-bold">{this.props.data[key].aInjuriesUnknown}</td>
                  <td className="numberTotals">{this.props.data[key].otherInjuriesTotal}</td>
                  <td className="numberTotals">{this.props.data[key].otherInjuriesUsed}</td>
                  <td className="numberTotals">{this.props.data[key].otherInjuriesNotUsed}</td>
                  <td className="numberTotals border-right-bold">{this.props.data[key].otherInjuriesUnknown}</td>
                  <td className="numberTotals">{this.props.data[key].noInjuriesTotal}</td>
                  <td className="numberTotals">{this.props.data[key].noInjuriesUsed}</td>
                  <td className="numberTotals">{this.props.data[key].noInjuriesNotUsed}</td>
                  <td className="numberTotals">{this.props.data[key].noInjuriesUnknown}</td>
                </tr>
              )}
            </tbody>
          </table>
        )}
        <p className="notes">Age information may not have been collected for uninjured passengers.</p>
      </React.Fragment>
    );
  }
}
